<div class="aeg-invoices">
    <Panel header="Facturen en betalingsbewijzen">
        <template v-if="!isMobile">
            <div class="aeg-invoices__search">
                <aeg-search-invoice @search="onSearch" :default-query="defaultSearchQuery" />
            </div>
        </template>
        <template v-if="error">
            <aeg-error-loading
                error-message="Er ging iets mis bij het ophalen van uw facturen en betalingsbewijzen."
                @try-again="loadInvoices"
                style="padding: 2rem;"
            />
        </template>
        <template v-else-if="isMobile">
            <template v-if="emptyState">
                <div class="p-datatable-empty-message">U heeft nog geen facturen of betalingsbewijzen.</div>
            </template>
            <template v-else>
                <div v-if="isLoading">
                    <aeg-loader />
                    <div class="aeg-spacer" />
                </div>
                <div v-else>
                    <aeg-invoice-cards :invoices="invoices" />
                </div>
                <div>
                    <aeg-paginator :paging-info="invoices.pagingInfo" />
                </div>
            </template>
        </template>
        <template v-else>
            <aeg-invoices-table
                :invoices="invoices"
                :download-file-uri="downloadFileUri"
                :show-download-link="true"
                :is-loading="isLoading"
                @change-page="changePage"
            />
        </template>
    </Panel>
</div>
